import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Button, Form, Table } from 'react-bootstrap';
import Auth from '../middleware/auth';
import config from '../config';
import Mensajes from './subcomponent/mensajes'
//import { ModalFooter } from 'react-bootstrap';
//import home from "./home.jsx"
//import {Alert} from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';

class login_clientes extends Component {

    constructor(props) {
        super(props);
        const state = Auth.isAuthenticated()
        this.state = {
            msg: 0,
            compc: "",
            usernamec: "",
            passwordc: "",
            isLogin: state,
            mostrarMensaje: false,
            mensaje: "",
            show: false
        }
    }

    handleClose = () => this.setState({ show: false });
    //handleShow = () => this.setState({ show: true });

    validateForm = () => {
        return this.state.usernamec.length > 0 && this.state.passwordc.length > 0 && this.state.compc.length > 0;

    }

    redirect = () => {
        this.setState({ isLogin: true })
    }

    validarEnter = (e) => {
        if (e.keyCode === 13) {
            if (this.validateForm()) {
                this.handleSubmit()

            }
        }
    }

    handleSubmit = () => {
        const { compc } = this.state
        const { usernamec } = this.state
        const { passwordc } = this.state

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                companyc: compc,
                userc: usernamec,
                passc: passwordc
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }

        fetch(config.servBackEnd + '/users/logincust', datasend)
            .then(res => res.json())
            .then((data) => {
                const usuario = (data.data) ? data.data : null;
                if (usuario && usuario[0].length > 0) {
                    const current = (usuario[0][0]);
                    Auth.setIdLogin( current.DOCUMENTO_CLIENTE, current.ID_EMPRESA, current.TIPO_USUARIO, current.RAZON_SOCIAL, current.VENDEDOR_ASOCIADO, current.NOMBRE_CLIENTE, current.ID_CLIENTE);
                    Auth.setPermisos(current)
                    //this.setState({ show: true });
                    Auth.login(this.redirect);
                }
                else {
                    this.setState({ mostrarMensaje: true, mensaje: "Usuario y clave invalida" })
                    //console.log("CREDENCIALES INCORRECTAS")
                }
            })
            .catch((error) => console.error(error))

    }

    render() {
        if (!this.state.isLogin) {
            //const { noticias } = this.state;
            return (
                <div className="fondoLogin" style={{background: 'url("/fondoLogin.jpeg") center no-repeat', backgroundPositionY: '150px'}}>
                    <div style={{ paddingRight: "15px" }}>
                        <section id="logo">
                            <img src="/logoLogin.png" height="170px" width="300px" alt="logo" />
                        </section>
                    </div>
                    <h1 style={{fontFamily: 'Verdana', color:"#08088A"}}>Clientes</h1>

                    <div className="login">
                        <center>
                            <Table style={{ width: 350 }}>
                                <tbody>
                                    <tr>
                                        <td style={{ background: "#08088A", borderRadius: "10px", boxShadow: "10px 10px 30px #9E9E9E" }}>

                                            <center>
                                                <Form>
                                                    <Form.Group>
                                                        <Form.Label htmlFor="company_id" style={{ color: "white" }}><h5>Company:</h5></Form.Label>
                                                        <Form.Control type="text" id="company_id" name="company_id" onKeyUp={this.validarEnter} onChange={e => this.setState({ compc: e.target.value })} value={this.state.comp} placeholder="Enter company" style={{ width: 280 }} />
                                                    </Form.Group>
                                                    <Form.Group>
                                                        <Form.Label htmlFor="user_id" style={{ color: "white" }}><h5>Nit o cédula:</h5></Form.Label>
                                                        <Form.Control type="text" id="user_id" name="user_id" onKeyUp={this.validarEnter} onChange={e => this.setState({ usernamec: e.target.value })} value={this.state.usernamec} placeholder="Enter company" style={{ width: 280 }} />
                                                    </Form.Group>

                                                    <Form.Group>
                                                        <Form.Label htmlFor="pass" style={{ color: "white" }}><h5>Password</h5></Form.Label>
                                                        <Form.Control type="password" id="pass" name="pass" onKeyUp={this.validarEnter} onChange={e => this.setState({ passwordc: e.target.value })} value={this.state.passwordc} placeholder="Password" style={{ width: 280 }} />
                                                    </Form.Group>
                                                    <Button onClick={this.handleSubmit} size="lg" style={{ background: "#FFFFFF" }} disabled={!this.validateForm()} >
                                                        <h5 style={{ color: "#08088A" }}>Login</h5>
                                                    </Button>
                                                </Form>
                                            </center>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </center>
                    </div>
                    <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
                   
                </div>


            );
        } else {
            return (<Redirect to={{ pathname: "/home" }} />);
        }
    }
}
export default (login_clientes);